'use client';

import { useKeenSlider } from 'keen-slider/react';
import { useState } from 'react';
import classNames from 'classnames';
import { GetPageComponentViewModel } from '@/types/cml-api';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import Skeleton from './skeleton';
import TestimonialItem from './testimonial-item';
import { deviceTypeClassGenerator } from '../../_utils/device-type-handlers';
import { IsLoadingLazyProps } from '../../type';
interface Props extends IsLoadingLazyProps {
  data: GetPageComponentViewModel;
  isLazy: boolean;
}
export function Testimonial({
  data,
  isLazy
}: Props) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(PUBLIC_IS_BOT);
  const hasSingleItem = data.items?.length === 1;
  const origin = 'center';
  const [sliderRef] = useKeenSlider<HTMLElement>({
    initial: 0,
    rtl: data.items?.length && data.items?.length > 2 ? true : false,
    loop: !hasSingleItem,
    slides: {
      perView: 1.1,
      spacing: 4,
      origin
    },
    breakpoints: {
      '(min-width: 992px)': {
        slides: {
          perView: 2.3,
          spacing: 8,
          origin
        }
      }
    },
    ...(hasSingleItem ? {} : {
      defaultAnimation: {
        duration: 2500
      }
    }),
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    }
  }, []);
  const carouselItems = data.items?.map((item, idx) => <TestimonialItem key={item?.id || item.link} index={idx} isLazy={isLazy || idx !== 0} sortKey={data?.sortKey} componentId={data?.id} currentSlide={currentSlide} {...item} />);
  return <div className={`homepage-container group relative h-[154px] lg:h-auto`} data-sentry-component="Testimonial" data-sentry-source-file="testimonial.tsx">
            <div ref={sliderRef} id={data.id || ''} className={classNames('keen-slider', deviceTypeClassGenerator(data.deviceTypes || ''), {
      invisible: !loaded
    })}>
                {carouselItems}
            </div>
            {!loaded && <Skeleton />}
        </div>;
}